import { css, animations } from "../../sitches.config";

const styles = {
  overlayWrap: css({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // Above the checkout overlay (z-[5001]) so the waitlist popup stacks on top
    // of the date picker rather than requiring the checkout to be closed first.
    zIndex: 6000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),

  overlay: css({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    backgroundColor: "rgba(0,0,0,0.8)"
  }),

  closeButton: css({
    position: "absolute",
    top: 0,
    right: 0,
    padding: 10,
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    "-webkit-appearance": "none",
    cursor: "pointer",

    "& svg": {
      display: "block"
    }
  }),

  container: css({
    position: "relative",
    backgroundColor: "white",
    borderRadius: 10,
    width: "90vw",
    maxWidth: 500,
    maxHeight: "90vh",
    padding: 30,
    overflow: "auto",
    animation: `${animations.popout} 250ms, ${animations.fadeIn} 250ms`,
    zIndex: 2
  }),

  form: css({
    position: "relative"
  }),

  fields: css({
    display: "grid",
    gridTemplateColumns: "1fr",
    gridAutoRows: "auto",
    gap: "10px",
    marginBottom: 20,

    "@md": {
      gridTemplateColumns: "1fr 1fr"
    }
  }),

  info: css({
    marginBottom: 15
  }),

  choice: css({
    marginBottom: 15
  }),

  choiceLabel: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$14",
    color: "$gray",
    lineHeight: 1.25,
    marginBottom: 6
  }),

  choiceButtons: css({
    display: "flex",
    border: "1px solid $mercury",
    borderRadius: 4,
    overflow: "hidden"
  }),

  choiceButton: css({
    flex: 1,
    padding: "10px 12px",
    backgroundColor: "white",
    border: "none",
    borderRadius: 0,
    cursor: "pointer",
    fontFamily: "$foundersGrotesk",
    fontSize: "$16",
    lineHeight: 1.1,
    color: "$gray",
    textAlign: "center",
    "-webkit-appearance": "none",
    transition: "background-color 150ms, color 150ms",

    "&:not(:last-child)": {
      borderRight: "1px solid $mercury"
    },

    variants: {
      active: {
        true: {
          backgroundColor: "$emeraldish",
          color: "white",
          fontWeight: 600
        },
        false: {}
      }
    }
  }),

  box: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$18",
    lineHeight: 1.1,
    padding: 15,
    border: "1px solid $mercury",
    borderRadius: 4
  }),

  alternatives: css({
    marginTop: 20,
    paddingTop: 15,
    borderTop: "1px solid $mercury"
  }),

  alternativesTitle: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$16",
    fontWeight: 600,
    lineHeight: 1.1,
    marginBottom: 4
  }),

  alternativesIntro: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$14",
    color: "$gray",
    lineHeight: 1.25,
    marginBottom: 10
  }),

  alternativesList: css({
    display: "flex",
    flexDirection: "column",
    gap: 8
  }),

  alternativeItem: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    width: "100%",
    padding: "10px 12px",
    backgroundColor: "white",
    border: "1px solid $mercury",
    borderRadius: 4,
    cursor: "pointer",
    textAlign: "left",
    fontFamily: "$foundersGrotesk",
    fontSize: "$16",
    lineHeight: 1.2,
    color: "$ebonyClay",
    "-webkit-appearance": "none",
    transition: "border-color 150ms",

    "&:hover": {
      borderColor: "$emeraldish"
    }
  }),

  alternativeSpaces: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$14",
    color: "$emeraldish",
    whiteSpace: "nowrap"
  }),

  similarNextDate: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$14",
    color: "$gray",
    whiteSpace: "nowrap"
  }),

  title: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "inherit",
    fontWeight: 600,
    lineHeight: 1,
    marginTop: 0,
    marginBottom: "$2"
  }),

  introTitle: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$20",
    lineHeight: 1,
    fontWeight: 600,
    marginBottom: 8
  }),

  intro: css({
    marginBottom: 15
  }),

  introText: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$18",
    color: "$gray",
    lineHeight: 1.25,

    "&:not(:last-child)": {
      marginBottom: 10
    }
  }),

  errorText: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$14",
    color: "$red",
    lineHeight: 1.25,
    marginTop: 4
  }),

  buttonContainer: css({
    display: "flex",
    justifyContent: "flex-end"
  }),

  formOverlay: css({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),

  completeText: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$18",
    textAlign: "center"
  }),

  completeButton: css({
    display: "flex",
    justifyContent: "center"
  }),

  loaderSpinner: css({
    width: 40,
    height: 40,
    border: "6px solid $emeraldish",
    borderTopColor: "transparent",
    borderRadius: "50%",
    animation: `${animations.rotate} 1s ease-in-out infinite`
  })
};

export { styles as WaitingListPopupStyles };
